<template>
  <div class="container px-2 overflow-y-auto">
    <div class="flex flex-wrap -mx-2 justify-center mt-5">
      <v-card
        raised
        class="mx-auto w-full mt-10 overflow-y-scroll h-90"
        width="1000"
      >
        <v-toolbar color="primary"  class="tool_bar"  :dark="true">
          
          <v-toolbar-title style="fon" class="flex text-center title_text"
            >Comments to my advisor for the {{ getSemesterName(selectedTerm) }} term:</v-toolbar-title
          >
        </v-toolbar>

        <v-card-text>
          <div
            v-if="messages === undefined || messages.length <= 0"
            class="w-full justify-center content-center"
          >
            <span>Looks like there are no comments for now!</span>
          </div>
          <div
            v-else
            v-for="message in messages"
            :key="message.id"
            class="flex w-full"
          >
            <div class="w-1/2 flex justify-start">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    v-on="on"
                    class="
                      bg-gray-300
                      p-3
                      text-black
                      rounded
                      overflow-hidden
                      text-semibold
                      break-words
                    "
                  >
                    {{ message.message }}
                  </p>
                </template>
                <span>{{ message.name }}</span>
                <span>({{ message.created_at }})</span>
              </v-tooltip>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <div class="row">
            <div class="col-sm-12 col-md-7 px-4">
              <v-textarea
                class="pr-4"
                :disabled="disableSendingMessage"
                rows="3"
                v-model="newmessage"
                outlined
              ></v-textarea>
            </div>
            <div class="col-sm-12 col-md-5 px-4">
              <button class="btn btn-success pl-4" @click="sendMessage()">
                Save Comment
              </button>
              <v-btn icon class="mx-0" @click="fetchApp()"
                ><v-icon color="blue" title="Refresh Comments"
                  >refresh</v-icon
                ></v-btn
              >
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </div>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<style>
@media only screen and (max-width: 768px) {
  .row {
    display: flex !important;
    flex-flow: column wrap !important;
  }
  .title_text {
  font-size:75%;
  }
  .tool_bar {
  height: 40;
  }
}
</style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      snack: false,
      snackColor: "",
      snackText: "",
      newmessage: "",
      messages: [],
      disableSendingMessage: false,
      appName: "/" + process.env.MIX_APP_NAME,
    };
  },
  computed: {
    ...mapState({
      studentDetailsFromStore: (state) => state.student,
      termFromStore: (state) => state.term,
    }),
    studentId: {
      get() {
        return this.studentDetailsFromStore.currentStudentUin;
      },
      set(newName) {
        return newName;
      },
    },
    created_by: {
      get() {
        return this.studentDetailsFromStore.isAdvisor == true
          ? this.studentDetailsFromStore.advisorUin
          : this.studentDetailsFromStore.currentStudentUin;
      },
      set(newName) {
        return newName;
      },
    },
    selectedTerm: {
      get() {
        return this.termFromStore.selected;
      },
      set(newName) {
        return newName;
      },
    },
  },
  created() {
    //   var self = this;
    //   Event.$on('current-student-uin', function (uin) {
    //       self.studentId = uin;
    //       if(self.created_by == '')
    //       {
    //       self.created_by = uin;
    //       }
    //   self.fetchApp();
    //   });
    //   Event.$on('selected-term', function (term) {
    //       self.selectedTerm = term;
    //   self.fetchApp();
    //   });
  },
  watch: {
    selectedTerm: function (val) {
      this.fetchApp();
      this.listen();
    },
    studentId: function (val) {
      this.fetchApp();
      this.listen();
    },
  },
  mounted() {},
  methods: {
    async fetchApp() {
      await axios
        .get("/api/v1/messageapi?semester=" +
            this.selectedTerm +
            "&uin=" +
            this.studentId
        )
        .then((response) => {
          this.messages = response.data;
        })
        .catch((error) => {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Oops! Something went wrong!";
          this.loadingForm = false;
          this.disableSendingMessage = false;
        });
    },
    async sendMessage() {
      this.disableSendingMessage = true;
      await axios
        .post("/api/v1/messageapi", {
          semester: this.selectedTerm,
          uin: this.studentId,
          created_by: this.created_by,
          message: this.newmessage,
        })
        .then((response) => {
          if (response.status === 200) {
            this.fetchApp();
            this.snack = true;
            this.snackColor = "success";
            this.snackText = "Your comment has been saved!";
          } else {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Oops! Something went wrong!";
          }
          this.newmessage = "";
          this.disableSendingMessage = false;
          this.loadingForm = false;
        })
        .catch((error) => {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Oops! Something went wrong!";
          this.loadingForm = false;
          this.disableSendingMessage = false;
        });
    },
    listen() {
      var self = this;
      var id = self.selectedTerm + self.studentId;
      if (id.length === 15) {
        Echo.join("alert." + id)
          .joining((user) => {
            this.snack = true;
            this.snackColor = "info";
            this.snackText =
              user.full_name + " has joined the messages channel";
          })
          .leaving((user) => {
            this.snack = true;
            this.snackColor = "info";
            this.snackText = user.full_name + " has left the messages channel";
          })
          .listen("NewMessage", (message) => {
            this.messages.push(message);
          });
      }
    },
	getSemesterName(term_cd)
        {
        var semester_name = '';
        var sem_year = term_cd.substring(1, 5);
        var semester_initial = term_cd.substring(5);

        if(semester_initial == '5')
        {
            semester_name = 'Summer ' + sem_year;
        }
        else if(semester_initial == 1)
        {
            semester_name = 'Spring ' + sem_year;
        }
        else
        {
            semester_name = 'Fall ' + sem_year;
        }

        return semester_name;
        },
  },
};
</script>
